var map = {
	"./bag.svg": "a695",
	"./bagBlack.svg": "987c",
	"./clock.svg": "0fbd",
	"./clockBlack.svg": "e89f",
	"./contactDetails.svg": "b646",
	"./contactDetailsBlack.svg": "bad4",
	"./menu.svg": "39c4",
	"./menuBlack.svg": "4add",
	"./payment.svg": "451c",
	"./paymentBlack.svg": "e17f",
	"./table.svg": "1bc9",
	"./tableBlack.svg": "f32e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";